__turbopack_context__.v({
  "body": "style-module-scss-module__mLrdTq__body",
  "container": "style-module-scss-module__mLrdTq__container",
  "social": "style-module-scss-module__mLrdTq__social",
  "socialBlock": "style-module-scss-module__mLrdTq__socialBlock",
  "text": "style-module-scss-module__mLrdTq__text",
});
